import type { AccountSummaryFigures } from "@/pages/reports/summary-by-close-date/models/SummaryByCloseDate";

export interface DateRangeSummaryRow extends AccountSummaryFigures {
	CostCenterName: string | null;
	StartDate: string | null;
	CloseDate: string | null;
	NumRegsFound: number | null;
}

/**
 * The procedure returns calendar dates. Reading them through a Date would shift them a
 * day in any timezone west of UTC, so the text is rearranged instead.
 */
export const toSheetDate = (value: string | null | undefined): string => {
	const match = value?.match(/^(\d{4})-(\d{2})-(\d{2})/);
	return match ? `${match[2]}/${match[3]}/${match[1]}` : "";
};

export const DATE_RANGE_HEADER_HELP = {
	start: "Start of the first monthly close added into this summary",
	close: "End of the last monthly close added into this summary",
	registers: "How many monthly closes this summary adds up",
} as const;
